<div class="login-overlay">
  <section class="login-overlay__container">

    <app-one-factor
      *ngIf="loginType === 1"
      [userEmail]="userEmail"
      [userName]="userName"
      (toggleLoginType)="toggleLoginType($event)"
      (closeOverlay)="handleCloseOverlay($event)">
    </app-one-factor>

    <app-two-factor
      *ngIf="loginType === 2"
      [sessionID]="sessionID"
      [userEmail]="userEmail"
      [userHasPassword]="userHasPassword"
      [userHasPhoneNumber]="userHasPhoneNumber"
      (toggleLoginType)="toggleLoginType($event)"
      (closeOverlay)="handleCloseOverlay($event)">
    </app-two-factor>

  </section>
</div>